import { useNavigate } from 'react-router'

import BackLink from '@/elements/BackLink'
import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import Tabs from '@/components/Tabs'
import organizationIndividualTabs from '@/router/tabsSystems/organizationIndividualTabs'

function IndividualSettings() {
  const navigate = useNavigate()

  return (
    <Flex component='section' gap={4} grow>
      <BackLink onBackOverride={() => navigate('/organization/individuals')} />
      <Text variant='h1'>Individual Settings</Text>
      <Tabs tabs={organizationIndividualTabs} />
    </Flex>
  )
}

export default IndividualSettings
